import { FeatureFlagsProvider, FeatureFlagsReady } from '@susu/feature-flags/react';
import type { ReactNode } from 'react';
import { type FeatureFlagsConfig, toFeatureFlagAttributes } from './attributes';
import { FEATURE_FLAGS_CLIENT_KEYS } from './config';
import { useEnvironmentContext } from '../providers/hooks/useEnvironmentContext';
import { ApplicationId } from '@susu/custom-made/Avo';
import { normalizeEnvironment } from '@susu/custom-made/utils/utils';

interface CustomMadeFeatureFlagsProviderProps {
  children: ReactNode;
  config: FeatureFlagsConfig;
  fallback?: ReactNode;
}

export function CustomMadeFeatureFlagsProvider({
  children,
  config,
  fallback,
}: Readonly<CustomMadeFeatureFlagsProviderProps>) {
  const environment = normalizeEnvironment(useEnvironmentContext().env);

  // Flags only, no experiments: no `identity`, so no `id` is sent and nothing is
  // tracked. To run one, add `identity={useSegmentIdentity()}` and wire
  // `onExperimentViewed` to Avo's `experimentViewed` once custom-made's Avo plan
  // has that event.
  return (
    <FeatureFlagsProvider
      clientKey={FEATURE_FLAGS_CLIENT_KEYS[environment]}
      applicationId={ApplicationId.CUSTOM_MADE}
      environment={environment}
      attributes={toFeatureFlagAttributes(config)}
    >
      <FeatureFlagsReady fallback={fallback}>{children}</FeatureFlagsReady>
    </FeatureFlagsProvider>
  );
}
